import { DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Alert, Button, Card, Space } from 'antd'

import ProductSourceAddUpload from './ProductSourceAddUpload'
import BatchImportProvider from '../../../context/BatchImportContext'

function AddBatchProductSource(): JSX.Element {
  const handleDownloadClick = () => {
    const a = document.createElement('a')
    a.style.display = 'none'
    a.download = 'APT_Template.xlsx'
    a.href = `${APP_URL}/assets/APT_Template.xlsx`
    a.click()
    a.remove()
  }

  return (
    <BatchImportProvider initialMode="apt">
      <h1 className="pb-4">Add New Products</h1>
      <Card
        title={
          <Alert
            title={
              <p className="text-xs font-medium">
                <span className="text-sm">Download template</span> - Sample file
                to add new products in bulk.
              </p>
            }
            type="info"
            className="bg-gray-25 !border-gray-200 py-3 text-gray-600 text-sm"
            action={
              <Space>
                <Button
                  className="flex-1 border border-solid rounded-lg !border-gray-300 hover:!border-gray-200 !text-gray-700 hover:!text-gray-900 !h-auto py-2"
                  icon={<DownloadOutlined />}
                  onClick={handleDownloadClick}
                >
                  Download
                </Button>
              </Space>
            }
            closable={false}
          />
        }
        className="pt-4 [&>.ant-card-body]:py-4 [&>.ant-card-head]:border-none"
      >
        <ProductSourceAddUpload />
        <Card.Meta
          className="pt-4"
          description={
            <p className="text-xs">
              <InfoCircleOutlined className="mr-1 text-primary-600" />
              This file only adds new products. Each row must include the
              necessary product details.
            </p>
          }
        />
      </Card>
    </BatchImportProvider>
  )
}

export default AddBatchProductSource
